<template>
    <div :class="['pl-5 py-3 z-30 relative ', alwaysOpenOnTop ? 'w-full flex justify-center sm:justify-end' : 'flex justify-end lg:justify-start pr-8 lg:pr-5']">
        <div ref="langSwitch" @focusout="handleFocusOut" tabindex="0">
            <div
                @click="handleClick"
                :class="['flex items-center cursor-pointer', alwaysOpenOnTop ? 'justify-center sm:justify-end' : 'justify-end lg:justify-start']">
                <DutchFlag v-if="activeLanguage === 'nl'" class="h-4 mr-3"/>
                <GermanFlag v-if="activeLanguage === 'de'" class="h-4 mr-3"/>
                <span class="text-sm mr-3 uppercase">{{ activeLanguage }}</span>
                <ArrowNext :fill="arrowColor ? arrowColor : '#034ad9'" :class="[langSwitchOpen ? '-rotate-90' : 'rotate-90']"/>
            </div>

            <div :class="[
                alwaysOpenOnTop ? 'flex justify-center items-center w-full px-4 absolute top-12 left-0 sm:left-auto sm:right-0 sm:w-auto sm:px-0' : 'w-full pr-6 lg:pr-5 pl-3 absolute left-0 bottom-12 sm:bottom-0 lg:bottom-auto lg:top-0',
            ]" v-if="langSwitchOpen">
                <div :class="[
                    'rounded bg-white shadow-md p-4 text-black',
                    alwaysOpenOnTop ? 'relative w-full sm:w-auto' : 'sm:absolute sm:mr-6 lg:mr-5 lg:ml-5 w-full sm:w-auto right-0 top-auto sm:bottom-12 lg:right-auto lg:left-0 lg:top-0 lg:bottom-auto',
                ]">
                    <div v-for="(language, index) in languages" @click="() => selectLanguage(language.route)"
                         :class="['flex items-center cursor-pointer pr-9', index !== (languages.length - 1) ? 'mb-4' : '']">
                        <DutchFlag v-if="language.locale === 'nl'" class="mr-2 h-4"/>
                        <GermanFlag v-if="language.locale === 'de'" class="mr-2 h-4"/>
                        <span class="text-sm">{{ $__(`menu.lang_${language.locale}`) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArrowNext from "@/Components/Icons/ArrowNext";
import DutchFlag from "@/Components/Flags/Dutch";
import GermanFlag from "@/Components/Flags/German";

export default {
    props: ['alwaysOpenOnTop', 'arrowColor'],
    data: () => ({
        langSwitchOpen: false,
        languages: [],
        activeLanguage: null,
    }),
    components: {ArrowNext, DutchFlag, GermanFlag},
    methods: {
        handleClick: function () {
            this.langSwitchOpen = !this.langSwitchOpen;
        },
        handleFocus: function () {
            this.langSwitchOpen = !this.langSwitchOpen;
        },
        handleFocusOut: function () {
            this.langSwitchOpen = false;
        },
        selectLanguage: function (url) {
            this.langSwitchOpen = false;
            this.$refs.langSwitch.blur();

            window.location.href = url;
        },
    },
    updated() {
        this.languages = this.$page.props.localizedRoutes;
        this.activeLanguage = this.$page.props.locale;
    }
}
</script>
